import React,{useMemo} from 'react';
import {Card, CardBody, CardTitle} from "reactstrap";
import {Bar} from "react-chartjs-2";

// components
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_CLOSE} from "../../../components/i18n/toolTips";
import {CountryFlags} from "../../../components/genericComponents/TranslatedLangs";
import MetricsDetailsTable from "./components/MetricsDetailsTable";


const TranslateStatisticsDetails = ({app, metrics, onClose, handleCalculateMetrics}) => {
    const { modules = [], activeLangsCodes = [] } = metrics || {};

    const chartData = useMemo(() => ({
        labels: modules.map(module => module.className.shortName),
        datasets: [
            {
                label: 'Registros Traducidos: ',
                data: modules.map(module => module?.percentageTranslatedRegisters),
                borderColor: 'rgb(96,140,48)',
                backgroundColor: 'rgba(96,140,48, .60)',
                borderWidth: 1
            }, {
                label: 'Registros Parcialmente Traducidos: ',
                data: modules.map(module => module?.percentagePartiallyTranslatedRegisters),
                borderColor: 'rgb(239, 152, 67)',
                backgroundColor: 'rgba(239, 152, 67, .60)',
                borderWidth: 1
            }, {
                label: 'Registros sin traducción: ',
                data: modules.map(module => module?.percentageUntranslatedRegisters),
                borderColor: 'rgb(234, 97, 53)',
                backgroundColor: 'rgba(234, 97, 53, .60)',
                borderWidth: 1
            }
        ]
    }), [modules]);

    const chartOptions = useMemo(() => ({
        responsive: true,
        plugins: {
            legend: { display: false },
            title: {
                display: true,
                text: `Detalle de Traducción`,
                font: { size: 16, weight: 'bold' }
            },
            datalabels: {
                display: true,
                color: 'black',
                font: { weight: 'bold' },
                formatter: value => (value === 0) ? '' : `${value}%`
            },
            tooltip: {
                callbacks: {
                    label: context => {
                        let label = context.dataset.label || '';
                        if (context.parsed.y !== null) label += context.parsed.y + '%';
                        return label;
                    }
                }
            }
        },
        scales: {
            y: {
                ticks: {
                    callback: value => value + '%'
                }
            }
        }
    }), []);

    return <Card className={'card-modal-medium-ex'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{app?.name}
            <div className="top-right">
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={onClose}
                />
            </div>
        </CardTitle>

        <CardBody className={'card-body-modal'}>
            <div className={'section-graphics-details-container'}>
                <div className={'section-graphics-details'}>
                    <Bar data={ chartData } options={ chartOptions } />
                </div>
            </div>

            <CountryFlags langs={activeLangsCodes} />

            <MetricsDetailsTable
                app={app}
                modules={modules}
                handleCalculateMetrics={handleCalculateMetrics}
            />
        </CardBody>
    </Card>
}
export default React.memo(TranslateStatisticsDetails)